import React, { useEffect, useState, useRef } from 'react';
import { Typography, Paper } from '@material-ui/core';
import { connect } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { DialogContent, DialogActions } from '../Dialog/Dialog';
import { getAllDrivers } from "../../../store/actions/vehicleActionCreator";
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete
} from 'mui-rff';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { numberFormat,findArrayObject, amountFormatOnly,isEmpty, getDateInStringDDMMMYYYY,numberWithCommas,checkNumberOnly,replaceCommas,sortByDisplay, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Form } from 'react-final-form';
import { logoutUser } from "../../../store/actions/authActionCreators";
import { withRouter, useHistory } from 'react-router-dom';
import useStyles from '../../pages/css/forms';
import DriverGaveAndGot from '../DriverDialogs/DriverGaveAndGot';
import AddDriver from '../AddDialogComponent/AddDialogComponent';
import { DialogTitle, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}

const filter = createFilterOptions({
    limit:30
  });

const DriverSelect = ({ props, defaultName, dispatchGetAllDrivers, onConfirm, onOpen, onClose, onSave, vehicle, dispatchAddNewDriver, type, fromSingleTruck }) => {

    const [dialogopen, setDialogOpen] = React.useState(onOpen);
    const [open, setOpen] = React.useState(false);
    const [driverValue, setDriverValue] = React.useState(null);
    const [driverListOpen, setDriverListOpen] = React.useState(false);
    const [driverListOptions, setDriverListOptions] = React.useState([]);
    const [addDriverOpen, toggleAddDriverOpen] = React.useState(false);
    const [driverDialogValue, setDriverDialogValue] = React.useState({
      name: '',
      number: '',
    });
    const handleAddDriverClose = () => {
      setDriverDialogValue({
        name: '',
        number: '',
      });
      toggleAddDriverOpen(false);
    };
    const handleDriverSave = (status, response) => {
      toggleAddDriverOpen(false);
      setDriverValue(response && response.id ? response : null);
    }
    const classes = useStyles();
    useEffect(() => {
        if (driverListOpen) {
            dispatchGetAllDrivers(null, null)
        }
    }, [driverListOpen]);

    const validate = values => {

        const errors = {};
        if ((!values.driver || !values.driver.id)) {
            errors.driver = 'Please Select a Driver';
        }
        return errors;
    };

    const handleClose = (status) => {
        onClose(false);
    };

    const onSubmit = values => {
        setDialogOpen(false);
        if (driverValue && driverValue.id) {
            onConfirm(driverValue);
        }
    }
    const driverDetails = [
        {
            size: 12,
            visible: false,
            field: (
              <Autocomplete
                classes={{
                  listbox: classes.listBoxAutoCompelete,
                  option: classes.listBoxOption
                }
                }
                id="select-driver-list"
                name="driver"
                size="small"
                onOpen={() => { setDriverListOpen(true) }}
                onClose={() => { setDriverListOpen(false) }}
                //defaultValue={driverDefaultValue?driverDefaultValue:null}
                value={driverValue}
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(event, newValue) => {
                  if (typeof newValue === 'string') {
                    // timeout to avoid instant validation of the dialog's form.
                    setTimeout(() => {
                      setDriverValue(null);
                      toggleAddDriverOpen(true);
                      setDriverDialogValue({
                        name: !checkNumberOnly(newValue) ? newValue : "",
                        number: checkNumberOnly(newValue) ? newValue : "",
                      });
                    });
                  } else if (newValue && newValue.inputValue) {
                    setDriverValue(null);
                    toggleAddDriverOpen(true);
                    setDriverDialogValue({
                      name: !checkNumberOnly(newValue.inputValue) ? newValue.inputValue : "",
                      number: checkNumberOnly(newValue.inputValue) ? newValue.inputValue : "",
                    });
                  } else if (newValue && newValue.inputValue === '') {
                    setDriverValue(null);
                    toggleAddDriverOpen(true);
                    setDriverDialogValue({
                      name: "",
                      number: "",
                    });
                  } else {
                    setDriverValue(newValue && newValue.id ? newValue : null);
    
                  }
    
                }}
                required={true}
                autoHighlight
                options={vehicle && vehicle.drivers ? vehicle.drivers : []}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                getOptionValue={option => option.id}
                getOptionLabel={(option) => {
                  // e.g value selected with enter, right from the input
                  if (typeof option === 'string') {
                    return '';
                  }
                  if (option.inputValue || !option.id) {
                    return '';
                  }
                  return option && option.name ? option.name : ''
                }}
                disableCloseOnSelect={false}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);
                  filtered.unshift({
                    inputValue: params.inputValue,
                    name: params.inputValue && params.inputValue.length > 1 ? `Add Details for"${params.inputValue}"` : `Add New Driver`,
                  });
                  return filtered;
                }}
                filterSelectedOptions
                renderOption={(option, { selected, inputValue }) => {
                  let matchesName, matchesNumber;
                  let partsName, partsNumber;
                  matchesName = match(option.name, inputValue);
                  partsName = parse(option.name, matchesName);
                  matchesNumber = match(option.contactNumber, inputValue);
                  partsNumber = parse(option.contactNumber, matchesNumber);
    
                  if (option && option.id) {
                    return (
                      <div className={classes.partyListItem}>
                        {partsName.map((part, index) => {
                          return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                            {part.text}
                          </span>
                          )
                        })}
                        {option.contactNumber && <>
                          <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                          {partsNumber.map((part, index) => {
                            return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                              {part.text}
                            </span>
                            )
                          })}
                        </>}
                      </div>
                    );
    
                  } else {
                    return (
                      <div className={classes.partyAddListItem}>
                        <AddPersonIcon className={classes.addPersonIcon} />
                        <span>{option.name}</span>
                        <ChevronRightIcon className={classes.cherveRightIcon} />
                      </div>
                    );
                  }
    
                }}
                textFieldProps={
                  {
                    label: "Select a Driver",
                    placeholder: "Select a Driver",
                    variant: "outlined",
                    margin: 'normal',
                  }
                }
                multiple={false}
              />
            ),
          }
    ]
    return (
        <>
            <div>
                <Dialog fullWidth={true}
                    maxWidth='xs'
                    onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogopen}>
                    <DialogTitle className={classes.dialogTitleV2}>
                        <div className={classes.fw300}>Choose Driver</div>
                        <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                        <Form
                            onSubmit={onSubmit}
                            initialValues={{driver:driverValue}}
                            validate={validate}
                            render={({ handleSubmit, form, submitting, pristine, values }) => (
                                <form onSubmit={handleSubmit} noValidate>
                                    {driverDetails.map((item, idx) => (
                                        item.field
                                    ))}
                                    <div>
                                        <Button className={classes.continue} variant="outlined" type="submit">
                                            Continue
                                        </Button>
                                    </div>
                                </form>
                            )}
                        />
                    </DialogContent>
                </Dialog>
            </div>
            {addDriverOpen && <AddDriver open={addDriverOpen} defaultName={driverDialogValue.name} defaultNumber={driverDialogValue.number} onClose={handleAddDriverClose} type={'driver'} onConfirm={handleDriverSave} fromTrip={true} />}
        </>
    )
}

const mapStateToProps = (state) => ({ vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispatchLogoutAction: () => dispatch(logoutUser()),
    dispatchGetAllDrivers: (onSuccess, onFailure) => dispatch(getAllDrivers(null, onSuccess, onFailure)),
});
const DriverSelectWithRouter = withRouter(DriverSelect);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DriverSelectWithRouter);